"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpikevaxBrand = void 0;
exports.SpikevaxBrand = {
    "Color-Brand-Spikevax-50": "#F5F8FA",
    "Color-Brand-Spikevax-100": "#EAF1F4",
    "Color-Brand-Spikevax-200": "#D0E1E7",
    "Color-Brand-Spikevax-300": "#B9D3DC",
    "Color-Brand-Spikevax-400": "#76A9BA",
    "Color-Brand-Spikevax-500": "#558FA2",
    "Color-Brand-Spikevax-600": "#427487",
    "Color-Brand-Spikevax-700": "#365E6E",
    "Color-Brand-Spikevax-800": "#30505C",
    "Color-Brand-Spikevax-900": "#2C444E",
    "Color-Brand-Spikevax-950": "#1D2D34"
};
//# sourceMappingURL=SpikevaxBrand.js.map